<template>
  <a-form :form="form" id="form">
    <a-form-item label="Note">
      <a-textarea
        placeholder="Write the note here ... "
        :rows="4"
        v-decorator="[
          'catatan_sppds',
          { initialValue: initialData.catatan_sppds },
        ]"
      />
    </a-form-item>
    <template v-if="mode == 'Create'">
      <a-form-item
        :label="item.actor"
        v-for="(item, index) in approvalDetail"
        :key="index"
      >
        <template v-if="item.tlc == null && item.name==null">
          <a-select
            v-decorator="[
              item.actor.replace(/\s/g, '').toLowerCase(),
              {
                rules: [{ required: true }],
              },
            ]"
          >
            <a-select-option
              v-for="item in approval"
              :key="item.value"
              :value="item.value"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </template>
        <a-input
          disabled
          v-else
          v-decorator="[
            item.actor.replace(/\s/g, '').toLowerCase(),
            {
              rules: [{ required: true }],
              initialValue: item.name,
              key: item.tlc,
            },
          ]"
        ></a-input>
      </a-form-item>
    </template>
    <template v-else>
      <a-row class="group-flex" v-for="item in approvalDetail" :key="item.tlc">
        <a-col span="6">
          <label>{{ item.actor }} Approval</label>
        </a-col>
        <a-col span="1">:</a-col>
        <a-col
          ><a-tag>{{ item.name }}</a-tag></a-col
        >
      </a-row>
    </template>
    <template v-if="mode == 'Create'">
      <template v-if="bodData.anybod === true">
        <a-form-item label="Director">
          <a-select
            v-decorator="[
              'director',
              {
                rules: [{ required: true }],
              },
            ]"
          >
            <a-select-option
              v-for="item in bodData.direktur"
              :key="item.value"
              :value="item.value"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </template>
    </template>
    <template v-else>
      <template v-for="item in informasi.approval">
        <template v-if="item.actor === 'Director'">
          <a-row class="group-flex" :key="item.tlc">
            <a-col span="6">
              <label>{{ item.actor }}</label>
            </a-col>
            <a-col span="1">:</a-col>
            <a-col
              ><a-tag>{{ item.name }}</a-tag></a-col
            >
          </a-row>
        </template>
      </template>
    </template>
  </a-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import _ from "lodash";

export default {
  props: {
    block: Object,
    data: {},
    mode: String,
    informasi: {},
    approvalDetail: Array,
    bod: Object,
  },
  name: "Persetujuan",
  data() {
    return {
      form: this.$form.createForm(this),
      dataValid: {},
      approval: [],
      bodData: this.bod,
      anybod: true,
    };
  },
  computed: {
    initialData: function () {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          catatan_sppds: "",
        };
      } else {
        return {
          catatan_sppds: this.data.catatan_sppds,
        };
      }
    },
    ...mapGetters(["getAuth"]),
  },
  mounted() {
    this.getComboApproval().then((res) => {
      this.approval = res.data.approval;
    });
  },
  methods: {
    clearForm() {
      this.form.resetFields();
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          console.log(err);
          return;
        }

        let approval = [];

        for (const [key, value] of Object.entries(values)) {
          if (key !== "catatan_sppds") {
            approval.push({ actor: key, tlc: value });
          }
        }

        let actorApproval = [];
        _.forEach(this.approvalDetail, (item) => {
          if (item.name !== null) {
            actorApproval.push({
              actor: item.actor.replace(/\s/g, "").toLowerCase(),
              tlc: item.tlc,
            });
          } else {
            _.forEach(approval, (data) => {
              if (data.actor == item.actor.replace(/\s/g, "").toLowerCase()) {
                actorApproval.push({ actor: data.actor, tlc: data.tlc });
              }
            });
          }
        });

        approval.forEach((item, index) => {
          if (item.actor === "director") {
            actorApproval.push({ actor: item.actor, tlc: item.tlc });
          }
        });

        const dataValues = {
          ...values,
          approval: actorApproval,
        };
        Event.$emit("collectData", { persetujuan: dataValues });
      });
    },
    handleRefBackPersetujuan() {
      this.form.validateFields((err, values) => {
        if (err) {
          console.log(err);
          return;
        }
        Event.$emit("collectDataBackPersetujuan", { persetujuan: values });
      });
    },

    async getComboApproval() {
      return await axios({
        method: "get",
        url: this.$serviceUrl + "sppds/approval_combo_v1",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });
    },
  },
};
</script>

<style lang="less">
.group-flex {
  display: flex;
  margin-top: @margin;
}
</style>
